import {
    ProductCategoryModel,
    DonatedTypes,
    ProductTypes,
    SOFARESCUE_CODE,
    BasketItemModel,
    BasketCareKitAddonModel,
    CARE_KIT,
    LEATHER_CARE_KIT_TYPE,
    FABRIC_CARE_KIT_TYPE,
    FREE_FABRIC_CARE_KIT_NAME,
    FABRIC_CARE_KIT_NAME,
    SOFASHIELD
} from 'models/Basket';

const SOFAGLIDE_CATEGORY = 'sofaGlideDefaultProducts';

export interface CareKitInfo {
    relatedCareKits: BasketCareKitAddonModel[];
    isCareKitInCart: boolean;
}

export class ProductHelper {
    public getProductTypeByCode(code: string, categories?: ProductCategoryModel[]): ProductTypes {
        if (code in DonatedTypes) {
            return ProductTypes.Donation;
        }

        if (categories?.some(c => c.code === SOFAGLIDE_CATEGORY)) {
            return ProductTypes.Sofaglide;
        }

        if (code === SOFARESCUE_CODE) {
            return ProductTypes.SofaRescue;
        }

        return ProductTypes.DefaultProduct;
    }

    public getProductTypeByName(name: string): ProductTypes {
        const isFabricCareKit = name.includes(FABRIC_CARE_KIT_TYPE.toLowerCase());

        if (isFabricCareKit) {
            return ProductTypes.FabricCareKit;
        }

        if (name.includes(CARE_KIT.toLowerCase()) && !isFabricCareKit) {
            return ProductTypes.LeatherCareKit;
        }

        if (name.includes(SOFASHIELD.toLowerCase())) {
            return ProductTypes.Sofashield;
        }

        return ProductTypes.DefaultProduct;
    }

    public getCareKitsInCart(entries: BasketItemModel[]): BasketItemModel[] {
        return entries.filter(entry =>
            entry.product.name?.toLowerCase().includes(CARE_KIT.toLowerCase()));
    }

    public getLoadedLeatherCareKits(loadedCareKits: BasketCareKitAddonModel[]): BasketCareKitAddonModel[] {
        return loadedCareKits.filter(carekit => carekit.materials.some(material => material === LEATHER_CARE_KIT_TYPE));
    }

    public getLoadedFabricCareKits(loadedCareKits: BasketCareKitAddonModel[]): BasketCareKitAddonModel[] {
        return loadedCareKits.filter(carekit => carekit.materials.some(material => material === FABRIC_CARE_KIT_TYPE));
    }

    public getCareKitsInfoForProduct(careKitsInCart: BasketItemModel[], itemIndex: number, loadedCareKits: BasketCareKitAddonModel[]): CareKitInfo {
        let relatedCareKits = loadedCareKits.filter(carekit => carekit.relatedCartEntries?.some(entry => entry === itemIndex));
        // Temporary block Fabric Care Kits
        if (relatedCareKits.some(carekit => carekit.name.toLowerCase() === FABRIC_CARE_KIT_NAME.toLowerCase() || carekit.name.toLowerCase() === FREE_FABRIC_CARE_KIT_NAME.toLowerCase())) {
            relatedCareKits = [];
        }

        const isCareKitInCart = careKitsInCart.some(careKit => relatedCareKits.find(relatedCareKit => relatedCareKit.name === careKit.product.name));

        return {
            relatedCareKits,
            isCareKitInCart
        };
    }
}

export const productHelper = new ProductHelper();